import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            keyup: {
                massedessais: 'toggleMassedessais',
                balourdresiduel: 'toggleBalourdresiduel',
                poidsdecorrection: 'togglePoidsdecorrection',
                platdacier: 'togglePlatdacier',
                ronddacier: 'toggleRonddacier',
                tubedacier: 'toggleTubedacier'
            },
        }
    }

    init() {

    }

    toggleMassedessais(e){
        let wr = document.getElementById('wr').value;
        let r = document.getElementById('r').value;
        let calc = 0;
        
        if(wr > 0 && r > 0) calc = 30 * (wr / r);
        e.currentTarget.closest('.b-onglet_calcul_component').getElementsByClassName('result')[0].innerHTML = calc.toFixed(1);
    }

    toggleBalourdresiduel(e){
        let g = document.getElementById('g2').value;
        let w = document.getElementById('w2').value;
        let n = document.getElementById('n2').value;
        let r = document.getElementById('r2').value;
        let calc = 0;

        if (g > 0 && w > 0 && n > 0 && r > 0) calc = (9549 * g * (w / n)) / r;
        e.currentTarget.closest('.b-onglet_calcul_component').getElementsByClassName('result')[0].innerHTML = calc.toFixed(1);
    }

    togglePoidsdecorrection(e) {
        let g = document.getElementById('g3').value;
        let w = document.getElementById('w3').value;
        let n = document.getElementById('n3').value;
        let r = document.getElementById('r3').value;
        let calc = 0;

        if (g > 0 && w > 0 && n > 0 && r > 0) calc = (((g / 1000) * r) * (2 * Math.PI * (n / 60))) / w;
        e.currentTarget.closest('.b-onglet_calcul_component').getElementsByClassName('result')[0].innerHTML = calc.toFixed(1);
    }

    togglePlatdacier(a) {
        let l = document.getElementById('l4').value;
        let e = document.getElementById('e4').value;
        let L = document.getElementById('L4').value;
        let calc = 0;

        if (l > 0 && e > 0 && L > 0) calc = l * e * L * 0.00785;
        a.currentTarget.closest('.b-onglet_calcul_component').getElementsByClassName('result')[0].innerHTML = calc.toFixed(1);
    }

    toggleRonddacier(e) {
        let d = document.getElementById('d5').value;
        let L = document.getElementById('L5').value;
        let calc = 0;

        if (d > 0 && L > 0) calc = (d * d * L * 6.165) / 1000;
        e.currentTarget.closest('.b-onglet_calcul_component').getElementsByClassName('result')[0].innerHTML = calc.toFixed(1);
    }

    toggleTubedacier(e) {
        let de6 = document.getElementById('de6').value;
        let di6 = document.getElementById('di6').value;
        let L = document.getElementById('L6').value;
        let calc = 0;

        if (de6 > 0 && di6 > 0 && L > 0) calc = ((de6 * de6 * L * 6.165) / 1000) - ((di6 * di6 * L * 6.165) / 1000);
        e.currentTarget.closest('.b-onglet_calcul_component').getElementsByClassName('result')[0].innerHTML = calc.toFixed(1);
    }
}
